export var TpaWidgetTypes;
(function (TpaWidgetTypes) {
    TpaWidgetTypes["BandsInTown_Widget"] = "BandsInTown_Widget";
    TpaWidgetTypes["Blog_Single_Post_Widget"] = "Blog_Single_Post_Widget";
    TpaWidgetTypes["Blog_Post_Gallery"] = "Blog_Post_Gallery";
    TpaWidgetTypes["Blog2_Custom_Feed_Widget"] = "Blog2_Custom_Feed_Widget";
    TpaWidgetTypes["Blog2_Post"] = "Blog2_Post";
    TpaWidgetTypes["Bookings_Widget"] = "Bookings_Widget";
    TpaWidgetTypes["Bookings_List"] = "Bookings_List";
    // Bookings = 'Bookings', uncomment it after merging AdiInstallBookCheckoutPage
    TpaWidgetTypes["Bookings_Book_Checkout"] = "Bookings_Book_Checkout";
    TpaWidgetTypes["Bookings_Service_Page"] = "Bookings_Service_Page";
    TpaWidgetTypes["Bookings_Calendar_Page"] = "Bookings_Calendar_Page";
    TpaWidgetTypes["Bookings_Form_Page"] = "Bookings_Form_Page";
    TpaWidgetTypes["Chat_Widget"] = "Chat_Widget";
    TpaWidgetTypes["Events"] = "Events";
    TpaWidgetTypes["Events_Single"] = "Events_Single";
    TpaWidgetTypes["Events_Multiple"] = "Events_Multiple";
    TpaWidgetTypes["Events_Schedule"] = "Events_Schedule";
    TpaWidgetTypes["GetSubscribers_Widget"] = "GetSubscribers_Widget";
    TpaWidgetTypes["Hotels_Search_Bar_Widget"] = "Hotels_Search_Bar_Widget";
    TpaWidgetTypes["Instagram_Widget"] = "Instagram_Widget";
    TpaWidgetTypes["DeviantArt_Widget"] = "DeviantArt_Widget";
    TpaWidgetTypes["Music_Widget"] = "Music_Widget";
    TpaWidgetTypes["ProGallery_Widget"] = "ProGallery_Widget";
    TpaWidgetTypes["PhotoAlbums_Widget"] = "PhotoAlbums_Widget";
    TpaWidgetTypes["Stores_Product_Widget"] = "Stores_Product_Widget";
    TpaWidgetTypes["Stores_Grid_Gallery_Widget"] = "Stores_Grid_Gallery_Widget";
    TpaWidgetTypes["Stores_Slider_Gallery_Widget"] = "Stores_Slider_Gallery_Widget";
    TpaWidgetTypes["Stores_Thank_You_Widget"] = "Stores_Thank_You_Widget";
    TpaWidgetTypes["Stores_Shopping_Cart_Widget"] = "Stores_Shopping_Cart_Widget";
    TpaWidgetTypes["Stores_Product_specific_Widget"] = "Stores_Product_specific_Widget";
    TpaWidgetTypes["Video_Widget"] = "Video_Widget";
    TpaWidgetTypes["Html_Embed"] = "Html_Embed";
    TpaWidgetTypes["RestaurantsMenus_Widget"] = "RestaurantsMenus_Widget";
    TpaWidgetTypes["RestaurantsOrders_Widget"] = "RestaurantsOrders_Widget";
    TpaWidgetTypes["RestaurantsOrders_NewWidget"] = "RestaurantsOrders_NewWidget";
    TpaWidgetTypes["RestaurantsReservations_Widget"] = "RestaurantsReservations_Widget";
    TpaWidgetTypes["Groups_SingleGroup"] = "Groups_SingleGroup";
    TpaWidgetTypes["Challenges_SingleChallenge"] = "Challenges_SingleChallenge";
})(TpaWidgetTypes || (TpaWidgetTypes = {}));
//# sourceMappingURL=tpa-widget-types.js.map